module.exports = __webpack_public_path__ + "static/media/medtronic.a7c7f875.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/medtronic.png
// module id = 281
// module chunks = 0